<!-- ingen [formGroup] da siden kun inneholder én formControl -->
<form (ngSubmit)="utfoer()">
<h2 mat-dialog-title>{{ "Bekreft sletting av signaturer"|translate }}</h2>
<mat-dialog-content class="bekreft-slett-signaturer-template">
  <p>{{ "Du er i ferd med å fjerne følgende signatarer som allerede har signert. Deres signatur vil bli permanent slettet." | translate }}</p>
  <ul>
    @for (signatar of signaturer; track signatar.id) {
      <li>
        {{ '{navn}, signert {dato} med {type}'|translate: {navn: signatar.medlem.navn, dato: signatar.signaturinformasjon.signertDato|zoneddatetime, type: signatar.signaturinformasjon.signaturtype|enum:'BenyttetSigneringsmetode'} }}
      </li>
    }
  </ul>
  <mat-form-field>
    <mat-label>{{ 'Angi årsak til slettingen'|translate }}</mat-label>
    <input type="text" matInput [formControl]="aarsak" data-testid="årsak-felt">
  </mat-form-field>
  <tips>
    {{ "Velg heller 'avslutt signering' dersom du ønsker å ta vare på disse signaturene men fortsatt ønsker å lås opp dokumentet som har blitt sendt til signering"|translate }}
  </tips>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button (click)="avbryt()">{{ "Avbryt"|translate }}</button>
  <button mat-raised-button color="warn" (click)="utfoer()" [disabled]="aarsak.invalid">{{ "Slett" | translate }}</button>
</mat-dialog-actions>
</form>
